import { axiosInstance } from "../config";

export default {
  state: {
    token: window.localStorage.getItem("token"),
  },
  mutations: {
    SetToken(state, payload) {
      state.token = payload;
    },
  },
  actions: {
    async AdminCkeck() {
      if (
        !window.localStorage.getItem("token") ||
        window.localStorage.getItem("token") == "undefined"
      ) {
        return;
      } else {
        return await axiosInstance
          .get(`/user/current`)
          .then(function (data) {
            if(data?.data?.username == 'admin'){
              return true
            }
            return false;
          })
          .catch(function (error) {
            return {
              error: error,
            };
          });
      }
    },
    async SignIn({ commit }, payload) {
      let body = {
        username: payload.username,
        password: payload.password,
      };
      let data = await axiosInstance
        .post("/admin/login", body)
        .catch(function (error) {
          return {
            data: {
              data: {
                error: error.response?.data?.message,
              },
            },
          };
        });
      if (data?.data?.success == true) {
        window.localStorage.setItem("token", data?.data?.data.token);
        commit("SetToken", data?.data?.data.token);
        return {
          success: true,
        };
      } else {
        return data?.data?.data;
      }
    },
    async Logout({ commit }) {
      return await axiosInstance
        .post("/admin/logout")
        .then(function (data) {
          window.localStorage.removeItem("token");
          commit("SetToken", "");
          return data?.data;
        })
        .catch(function (error) {
          window.localStorage.removeItem("token");
          commit("SetToken", "");
          window.location.reload();

          return {
            error: error.response.data.message,
          };
        });
    },
    async LogoutTerminate({ commit }) {
      return await axiosInstance
        .post("/admin/terminate")
        .then(function (data) {
          window.localStorage.removeItem("token");
          commit("SetToken", "");
          return data?.data;
        })
        .catch(function (error) {
          window.localStorage.removeItem("token");
          commit("SetToken", "");
          window.location.reload();

          return {
            error: error.response.data.message,
          };
        });
    },
    async ChangePassword({}, payload) {
      return await axiosInstance
        .patch("/admin/change_password", payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async SignUp({ commit }, payload) {
      let body = {
        username: payload.username,
        password: payload.password,
        password_confirmation: payload.password,
      };
      let data = await axiosInstance
        .post("/admin/register", body)
        .catch(function (error) {
          return {
            data: {
              data: {
                error: error.response?.data?.message,
              },
            },
          };
        });
      if (data?.data?.success == true) {
        window.localStorage.setItem("token", data?.data?.data.token);
        commit("SetToken", data?.data?.data.token);
        return {
          success: true,
        };
      } else {
        return data?.data?.data;
      }
    },
  },
  getters: {
    getToken: (state) => state.token,
  },
};
